export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_REJECT = "LOGIN_REJECT";
export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_REJECT = "REGISTER_REJECT";
export const CONFIRM_EMAIL_REQUEST = "CONFIRM_EMAIL_REQUEST";
export const CONFIRM_EMAIL_SUCCESS = "CONFIRM_EMAIL_SUCCESS";
export const CONFIRM_EMAIL_REJECT = "CONFIRM_EMAIL_REJECT";
export const USER_LOGOUT = "USER_LOGOUT";
export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_REJECT = "FORGOT_PASSWORD_REJECT";
export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_REJECT = "RESET_PASSWORD_REJECT";
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_REJECT = "CHANGE_PASSWORD_REJECT";
export const VALIDATE_USER_SUCCESS = "VALIDATE_USER_SUCCESS";
export const VALUDATE_USER_FAILED = "VALUDATE_USER_FAILED";



// WEBPACK FOOTER //
// ./src/users/loggedUser/constants.js